import React, { useCallback, useEffect } from "react";
import { DraftAlbum, useMusicApi } from "../../api/useMusicApi";
import { useLoading } from "../../hooks/use-loading";
import { Preloader } from "../../components/Preloader";
import { toast } from "react-toastify";
import { EditDraftForm } from "./EditDraftForm";
import { useGenres } from "../../hooks/use-genres";
import { useContractors } from "../../contexts/ContractorsContext";
import { usePageHelper } from "../../hooks/use-page-helper";
import { useAdvancedState } from "../../hooks/use-advanced-state";

export const AlbumPage: React.FC = () => {
  const { loadings, startLoading, stopLoading } = useLoading({
    album: true,
  });

  const api = useMusicApi();
  const [album, setAlbum, updateAlbum] = useAdvancedState<DraftAlbum>({});
  const { genres } = useGenres();
  const { contractors } = useContractors();

  const {
    t,
    routeParams: { id },
  } = usePageHelper(album?.country_meta?.title?.ALL ?? "", true);

  useEffect(() => {
    if (id != null) {
      fetchAlbum(id).then();
    }
  }, [id]);

  const fetchAlbum = useCallback(async (id: string) => {
    try {
      startLoading("album");
      const res = await api.getAlbum(id);
      setAlbum(res);
    } catch (e) {
      toast.error("Ошибка загрузки альбомов");
    } finally {
      stopLoading("album");
    }
  }, []);

  return (
    <>
      <div className={"w-100"}>
        {loadings.album ? (
          <Preloader className={"my-10"} size={"5x"} />
        ) : (
          <EditDraftForm
            isDraft={false}
            title={album?.country_meta?.title?.["ALL"] ?? t("album").toString()}
            entity={album ?? {}}
            genres={genres}
            validationErrors={[]}
            onChange={updateAlbum}
            contractors={contractors}
            onFileSelect={api.postUploadFile}
          />
        )}
      </div>
    </>
  );
};
